import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const CLASS_NAME = 'hidden lg:block';

export const businessGradients1: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#DCCFBB',
    id: 'orange-1',
    position: [52, 62],
    opacity: 0.8,
    size: 25,
    className: CLASS_NAME,
  },
  {
    shape: 'ellipse',
    hex: '#DCCFBB',
    id: 'orange-2',
    position: [95, 85],
    opacity: 0.8,
    size: 15,
    className: CLASS_NAME,
  },
];

export const businessGradients2: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#DCCFBB',
    id: 'orange-3',
    position: [10, 12],
    opacity: 0.8,
    size: 30,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#DCCFBB',
    id: 'orange-4',
    position: [33, 47],
    opacity: 0.8,
    size: 15,
    className: CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#DCCFBB',
    id: 'orange-5',
    position: [83, 85],
    opacity: 0.8,
    size: 20,
    className: CLASS_NAME,
  },
];

export const businessGradients3: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#DCCFBB',
    id: 'orange-3',
    position: [25, 12],
    opacity: 0.8,
    size: 15,
    className: CLASS_NAME,
  },

  {
    shape: 'circle',
    hex: '#DCCFBB',
    id: 'orange-5',
    position: [83, 85],
    opacity: 0.8,
    size: 20,
    className: CLASS_NAME,
  },
];
